import { render, staticRenderFns } from "./ShittyTextInput.vue?vue&type=template&id=cdfb68de&"
import script from "./ShittyTextInput.vue?vue&type=script&lang=ts&"
export * from "./ShittyTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./ShittyTextInput.vue?vue&type=style&index=0&id=cdfb68de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports